export const QUEUE_PARAM_NAME = "_fpapiqueue";
export const GLOBAL_FUNCTION_NAME = "fpAsyncInit";